import React from 'react';
//
import Box from '@material-ui/core/Box';
//
import InputLabel from '@atoms/InputLabel'; 
import InputField from '@atoms/InputField'; 




/** 
 * @component SelectField 
 * 
 * @props id    - input id
 * @props label -input label
 * @props field - control input react-hook-form
 * @props withIcon - bolean
 * @props options  - option array{ value: "",label: "",icon: "icon-url"}
 * */ 
export default function TextFeild(props) {
  console.log(props)
  return (
    <Box>
        <InputLabel  htmlFor={props.id}>
          {props.label}
        </InputLabel>

       <InputField
            style={{ marginTop: props.withoutLable ? 16 : 0 }}
            disabled={props.isSubmitted}
            {...props.field}
            inputProps={
                { 'aria-label':  'احصل على السعر'}
            }
        />
         
        <p style={{color: 'red', margin: 0}}>{props.error && "هذا الحقل مطلوب *"}</p>
    </Box>
  );
}





